if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.unreachedMessage = this.querySelector('.free-shipping-bar__unreached-message');
      this.reachedMessage = this.querySelector('.free-shipping-bar__reached-message');
      this.unreachedMessageText ||= this.unreachedMessage?.innerHTML;
      this.percentNumber = this.querySelector('.free-shipping-bar__progress-number');
      this.excludeMessage = this.querySelector('.free-shipping-bar__exclude-message');
      this.excludeMessageText ||= this.excludeMessage?.innerHTML;
      this.countExcludeProducts = Number(this.dataset.countExcludeProducts) || 0;
      this.threshold = Number(this.dataset.threshold);
      if (!this.threshold) return;
      this.calculateBar(Number(this.dataset.total) || 0);
      this.toggleExcludeMessage();
      this.revision = (this.revision || 0) + 1;
      this.onCartChangeHandler = () => this.onCartChange();
      this.cartEvents = ['afterCartChanged', 'afterUpdateQuantity', 'afterDiscountUpdate'];
      this.cartEvents.forEach(name => document.addEventListener(name, this.onCartChangeHandler));
      window.addEventListener('pageshow', this.onCartChangeHandler);
      this.onVisible = () => { if (!document.hidden) this.onCartChange(); };
      document.addEventListener('visibilitychange', this.onVisible);

      // Apps can replace the cart markup without dispatching the theme's events.
      this.observer = new MutationObserver(() => this.onCartChange());
      const items = document.querySelector('cart-drawer .cart-drawer__items');
      const icon = document.getElementById('cart-icon-bubble');
      const drawer = this.closest('cart-drawer');
      if (items) this.observer.observe(items, { childList: true });
      if (icon) this.observer.observe(icon, { childList: true, subtree: true });
      if (drawer) this.observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
      this.onCartChange();
    }

    disconnectedCallback() {
      this.revision++;
      clearTimeout(this.refreshTimer);
      this.observer?.disconnect();
      this.cartEvents?.forEach(name => document.removeEventListener(name, this.onCartChangeHandler));
      window.removeEventListener('pageshow', this.onCartChangeHandler);
      document.removeEventListener('visibilitychange', this.onVisible);
    }

    calculateBar(currentTotal) {
      const total = Math.max(0, currentTotal) / (parseFloat(Shopify.currency.rate) || 1);
      this.classList.toggle('completed', total >= this.threshold);
      if(total >= this.threshold) {
        this.style.setProperty('--percent', '100%');
        this.classList.add('completed');
        this.hideUnreachedMessage();
        this.showReachedMessage();
        this.percentNumber.textContent = `100%`;
      }  else {
        const remain = this.threshold - total;
        const percent = (total * 100) / this.threshold;
        this.style.setProperty('--percent', `${percent}%`);
        this.hideReachedMessage();
        this.showUnreachedMessage(remain);
        this.percentNumber.textContent = `${Math.floor(percent)}%`;
      }
    }

    toggleExcludeMessage() {
      if (!this.dataset.showExcludeMessage || !this.excludeMessage) {
          return
      }
      if (!this.countExcludeProducts) {
          this.excludeMessage.classList.add('hidden')
      } else {
          this.excludeMessage.innerHTML = this.excludeMessageText.replace('[product_count]', this.countExcludeProducts);
          this.excludeMessage.classList.remove('hidden')
      }
    }

    onCartChange() {
      const revision = ++this.revision;
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(async () => {
        try {
          const response = await fetch(`${routes.cart_url.replace(/\/$/, '')}.js`, {
            headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store'
          });
          if (!response.ok) return;
          const cart = await response.json();
          if (revision !== this.revision || !this.isConnected || !Number.isFinite(cart.total_price)) return;
          let total = cart.total_price;
          this.countExcludeProducts = 0;
          const excluded = typeof freeShippingBarExcludeProducts === 'undefined' ? [] : freeShippingBarExcludeProducts;
          cart.items.forEach(item => {
            if (excluded.includes(item.product_id)) {
              total -= item.final_line_price;
              this.countExcludeProducts++;
            }
          });
          this.dataset.total = Math.max(0, total);
          this.calculateBar(total);
          this.toggleExcludeMessage();
        } catch (_) {
          // Keep the last confirmed total when a request fails; retry on the next cart change.
        }
      }, 80);
    }

    showUnreachedMessage(remainAmount) {
      if(!this.unreachedMessageText || !this.unreachedMessage) return;
      const remainPrice = Shopify.showPrice(remainAmount);
      this.unreachedMessage.classList.remove('hidden');
      this.unreachedMessage.innerHTML = this.unreachedMessageText.replace('[remain]', `${remainPrice}`);
    }

    hideUnreachedMessage() {
      if(!this.unreachedMessage) return;
      this.unreachedMessage.classList.add('hidden');
    }

    showReachedMessage(remainAmount) {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.remove('hidden')
    }

    hideReachedMessage() {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.add('hidden');
    }
  });
}
